/* NIBBLE & NABBLE — COLLECTION FILTERS */
(function () {
  'use strict';
  var tabs = document.getElementById('nn-filter-tabs');
  var grid = document.getElementById('nn-product-grid');
  if (!tabs || !grid) return;

  tabs.addEventListener('click', function (e) {
    var tab = e.target.closest('.nn-tab');
    if (!tab) return;
    var filter = tab.dataset.filter;

    tabs.querySelectorAll('.nn-tab').forEach(function (t) { t.classList.remove('active'); });
    tab.classList.add('active');

    grid.querySelectorAll('.nn-product-grid__item').forEach(function (item) {
      var tags = (item.dataset.tags || '').split(' ');
      var show = (filter === 'all' || tags.indexOf(filter) !== -1); item.classList.toggle('nn-filter-hide', !show);
    });

    if (history.replaceState) {
      var url = filter === 'all' ? location.pathname : location.pathname + '?filter=' + filter;
      history.replaceState(null, '', url);
    }
  });

  var params = new URLSearchParams(location.search);
  var active = params.get('filter');
  if (active) {
    var btn = tabs.querySelector('[data-filter="' + active + '"]');
    if (btn) btn.click();
  }
})();
